module.exports = __webpack_public_path__ + "img/img10.06c37d34.png";